import { useState } from "react";
import { LANDING_URL } from "../../env";
import { useTranslation } from "react-i18next";
import AuthLayout from "../../components/Auth/AuthLayout";
import LearnMoreModal from "../../components/Auth/LearnMoreModal";
import Button from "../../components/Common/Button";
import LanguageToggle from "../../components/Common/LanguageToggle";

const RegisterSuccess = () => {
    const { t } = useTranslation();
    const [showLearnModal, setShowLearnModal] = useState(false);

    return (
        <>
            <div className="fixed top-6 right-6 z-50">
                <LanguageToggle />
            </div>
            <AuthLayout
                className="bg-white"
                left={(
                    <div className="relative h-56 w-full overflow-hidden bg-[#d9dde3] lg:h-screen">
                        <img
                            src="/assets/images/common/register-success.png"
                            alt=""
                            className="h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-[#d9dde3]/40" />
                    </div>
                )}
                right={(
                    <div className="flex flex-col justify-center px-6 py-10 sm:px-10 lg:px-16">
                        <div className="flex items-center gap-3 text-sm font-semibold tracking-[0.2em] text-slate-700">
                            <a href={LANDING_URL} className="hover:opacity-75 transition-opacity">
                                <img
                                    src="/assets/icons/korres-shares-logo.png"
                                    alt={t("AUTH_REGISTER_SUCCESS_ALT_KORRES_SHARES")}
                                    className="h-[4.5rem] w-[4.5rem]"
                                />
                            </a>
                        </div>

                        <div className="mt-10 max-w-md">
                            <h1 className="text-2xl font-semibold text-slate-900">
                                {t("AUTH_REGISTER_SUCCESS_TITLE")}
                            </h1>
                            <p className="mt-2 text-sm text-slate-500">
                                {t("AUTH_REGISTER_SUCCESS_SUBTITLE")}
                            </p>
                            <button
                                type="button"
                                onClick={() => setShowLearnModal(true)}
                                className="mt-4 text-xs font-semibold text-primary underline underline-offset-4 hover:opacity-75 focus:outline-none"
                            >
                                {t("AUTH_REGISTER_LEARN_MORE")}
                            </button>
                            <div className="mt-8">
                                <Button
                                    type="button"
                                    className="w-full"
                                    onClick={() => { window.location.href = LANDING_URL; }}
                                >
                                    {t("COMMON_BACK_TO_HOME")}
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            />

            <LearnMoreModal
                isOpen={showLearnModal}
                onClose={() => setShowLearnModal(false)}
            />
        </>
    );
};

export default RegisterSuccess;
